<script>
import loadingSkeleton from "./../../../package/loadingSkeleton.vue";
import packageCard from "./packageCard.vue";
import {mapActions} from "vuex";

export default {
  name: "packageCardLayout",
  data() {
    return {
      loading: true,
      plans: [],
      subscriptionPeriod: 'MONTHLY'
    }
  },
  watch: {
    selectedOption(newValue) {
      // You can emit an event or trigger other actions when the selection changes
      console.log('Selected option changed to:', newValue);

    }
  },
  components: {packageCard, loadingSkeleton},
  async created() {

    this.getUConnectSubscriptionProducts({ callback: this.getUConnectSubscriptionProductsCallback })

  },
  methods: {
    ...mapActions("uConnect", ["getUConnectSubscriptionProducts"]),
    getUConnectSubscriptionProductsCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        that.loading = false;
        let products = res.data.data;

        const excludedCodes = ['UCON_STND_ELITE', 'UCON_STND_FREE'];
        that.plans = products.filter(plan => {
          // Add a safety check for the nested property
          return plan.uconnectSubscription && !excludedCodes.includes(plan.uconnectSubscription.productCode);
        });
      }
    },
    selectedPackage(subscriptionId) {
      this.$emit('selectedPackage', subscriptionId, this.subscriptionPeriod);
    },
  }
}
</script>

<template>
  <div>
    <template v-if="plans.length > 0">
      <el-row :gutter="20" style="display: flex; align-items: center; justify-content: center; margin-bottom: 20px">
        <div class="toggle-container">
          <button
            class="toggle-option"
            :class="{ active: subscriptionPeriod === 'MONTHLY' }"
            @click="subscriptionPeriod = 'MONTHLY'"
          >
            Monthly
          </button>
          <button
            class="toggle-option"
            :class="{ active: subscriptionPeriod === 'YEARLY' }"
            @click="subscriptionPeriod = 'YEARLY'"
          >
            Yearly
          </button>
        </div>

      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" v-for="plan in plans" :key="plan.displayName">
          <package-card :plan="plan" @selectedPackage="selectedPackage" :subscriptionPeriod="subscriptionPeriod"/>
        </el-col>
      </el-row>

    </template>
    <template v-else>
      <loading-skeleton/>
    </template>
  </div>
</template>

<style scoped lang="scss">
.toggle-container {
  display: flex;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f1f1f1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.toggle-option {
  padding: 10px 24px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  border: none;
  transition: all 0.2s ease;
  min-width: 100px;
}

.toggle-option:focus {
  outline: none;
}

.toggle-option.active {
  background-color: #0a3c3e;
  color: white;
}

.toggle-option:not(.active) {
  background-color: #f1f1f1;
  color: #6b7280;
}
</style>



// WEBPACK FOOTER //
// src/components/register/uConnectRegistration/selectPackage/packageCardLayout.vue